import { render, staticRenderFns } from "./ClientDetails.vue?vue&type=template&id=5f0e0d3a&scoped=true&"
import script from "./ClientDetails.vue?vue&type=script&lang=js&"
export * from "./ClientDetails.vue?vue&type=script&lang=js&"
import style0 from "./ClientDetails.vue?vue&type=style&index=0&id=5f0e0d3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0e0d3a",
  null
  
)

export default component.exports